import store from "../store";
import { sendPasswordResetMessage } from "./restFunctions";

const resetPasswordSubmit = async (values, source) => {
  const {
    forms: { resetPasswordForm }
  } = store;
  store.setUI("formSubmitting", true);
  const { username } = values;
  await sendPasswordResetMessage(username, source)
    .then(response => {
      store.setUI("formSubmitting", false);
      const { isOK } = response;
      if (isOK) {
        store.setUI("passwordResetSent", true);
        store.setUI("snackbar", {
          visible: isOK,
          severity: "success",
          content: "Thank you, we've sent you an email to reset your password."
        });
        resetPasswordForm.clear();
      } else {
        const {
          forms: { sendPasswordResetMessageForm }
        } = store;
        sendPasswordResetMessageForm
          .$("username")
          .invalidate("Please enter the correct username");
      }
    })
    .catch(() => {
      store.setUI("formSubmitting", false);
    })
    .finally(() => {
      store.setUI("formSubmitting", false);
    });
};

export default resetPasswordSubmit;
